import { render, staticRenderFns } from "./QuestionTitlePill.vue?vue&type=template&id=481adf6a&"
import script from "./QuestionTitlePill.vue?vue&type=script&lang=ts&"
export * from "./QuestionTitlePill.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports